const getDefaultState = () => {
  return {
    name: '',
    namespace: '',
    entry: ''
  }
}
const state = getDefaultState()

const mutations = {
  SET_STATE: (state, { name, entry, namespace }) => {
    state.name = name
    state.namespace = namespace
    state.entry = entry
  }
}

const actions = {
  UPDATE_MFE({ commit }, payload) {
    commit('SET_STATE', payload)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
